import { colors } from "../styles/variables";
import {
  FontNames,
  FontWeights,
  TextTransform,
  HexColor,
} from "@pepdirect/shared/types";

type themeNameTypes =
  | "PantryShop"
  | "PepsiCoShop"
  | "TeamZone"
  | "SodaStream"
  | "Gatorade"
  | "MountainDew"
  | "MountainDewEnergy"
  | "RockstarEnergy"
  | "PepDefault";

export const themeNames: Record<themeNameTypes, string> = {
  PantryShop: "PantryShop",
  PepsiCoShop: "PepsiCoShop",
  TeamZone: "Gatorade TeamZone",
  SodaStream: "SodaStream Pro",
  Gatorade: "Gatorade",
  MountainDew: "Mountain Dew",
  MountainDewEnergy: "Mountain Dew Energy",
  RockstarEnergy: "Rockstar Energy",
  PepDefault: "Pep Default",
};

interface HeadingStyles {
  fontSize: {
    desktop: string;
    mobile?: string;
  };
  fontFamily?: FontNames;
  fontWeight?: FontWeights;
  letterSpacing?: string;
  lineHeight?: string;
  color?: HexColor;
  textTransform?: TextTransform;
}

export interface ThemeInterface {
  name: string;
  color: {
    primary: HexColor;
    secondary: HexColor;
    tertiary: HexColor;
    accent: HexColor;
    disabled: HexColor;
    action: HexColor;
    error: HexColor;
    text: HexColor;
  };
  button: {
    primary: {
      color: HexColor;
      textColor?: HexColor;
      hollow?: boolean;
      solidOnHover?: boolean;
    };
    secondary: {
      color: HexColor;
      textColor?: HexColor;
      hollow?: boolean;
      solidOnHover?: boolean;
    };
    tertiary: {
      color: HexColor;
      textColor?: HexColor;
      hollow?: boolean;
      solidOnHover?: boolean;
    };
    cancel: {
      color: HexColor;
      textColor?: HexColor;
      hollow?: boolean;
      solidOnHover?: boolean;
    };
    error: {
      color: HexColor;
      textColor?: HexColor;
      hollow?: boolean;
      solidOnHover?: boolean;
    };
    text: {
      color: HexColor;
    };
    disabled?: {
      hollow?: boolean;
    };
    fontFamily?: FontNames;
    fontWeight?: FontWeights;
    textTransform?: string;
    hasThinBorder?: boolean;
    borderRadius?: string;
  };
  typography: {
    body?: {
      fontSize?: string;
      fontFamily?: FontNames;
      fontWeight?: FontWeights;
      letterSpacing?: string;
      lineHeight?: string;
      color?: HexColor;
    };
    heading: {
      xxl: HeadingStyles;
      xl: HeadingStyles;
      l: HeadingStyles;
      m: HeadingStyles;
      s: HeadingStyles;
      xs: HeadingStyles;
      xxs: HeadingStyles;
    };
  };
  borderRadius?: string;
  page?: {
    backgroundColor?: HexColor;
  };
  header?: {
    backgroundColor?: HexColor;
    shopBackgroundColor?: HexColor;
    mobileLinkColor?: HexColor;
    navLinkColor?: HexColor;
    fontFamily?: FontNames;
    fontSize?: string;
    fontWeight?: FontWeights;
    textTransform?: TextTransform;
    navLinkOpacity?: string;
  };
  footer?: {
    backgroundColor?: HexColor;
    textColor?: HexColor;
    copyright?: {
      backgroundColor?: HexColor;
      textColor?: HexColor;
    };
  };
  alert?: {
    info?: {
      textColor?: HexColor;
    };
  };
  priceAccentColor?: HexColor;
  banner?: {
    backgroundColor?: HexColor;
  };
}

export type ThemeType = ThemeInterface;

// PepDefaultTheme includes only the required
// fields from ThemeInterface. Also, DefaultTheme
// is already taken hence PepDefaultTheme naming
export const PepDefaultTheme: ThemeInterface = {
  name: themeNames.PepDefault,
  color: {
    primary: colors.mediumGray,
    secondary: colors.mediumGray,
    tertiary: colors.mediumGray,
    accent: colors.mediumGray,
    disabled: colors.gray,
    action: colors.green,
    error: colors.red,
    text: colors.darkGray,
  },
  button: {
    primary: { color: colors.mediumGray },
    secondary: { color: colors.green },
    tertiary: { color: colors.mediumGray },
    cancel: { color: colors.mediumGray },
    error: { color: colors.red },
    text: { color: colors.mediumGray },
  },
  typography: {
    heading: {
      xxl: {
        fontSize: {
          desktop: "46px",
        },
      },
      xl: {
        fontSize: {
          desktop: "36px",
        },
      },
      l: {
        fontSize: {
          desktop: "24px",
        },
      },
      m: {
        fontSize: {
          desktop: "18px",
        },
      },
      s: {
        fontSize: {
          desktop: "16px",
        },
      },
      xs: {
        fontSize: {
          desktop: "14px",
        },
      },
      xxs: {
        fontSize: {
          desktop: "14px",
        },
        fontWeight: "400",
      },
    },
  },
};
